import BaseModel from '../core/BaseModel'
export default class ProductOrderDuplicateModel extends BaseModel {
    constructor() {
        super({ 
                name: "production_order",
                tableName: 'core_production_order'
            }, 
            {
            id : { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian tạo',
                width: 10
            },
            manufacturing_date: { 
                name: 'manufacturing_date', 
                type: "Date", 
                label: 'Ngày sản xuất',
                class: 'center',
                width: 10
            },
            amount: { 
                name: 'amount', 
                type: "String", 
                label: 'Số lượng',
                class: 'center',
                width: 8
            },
            status: { 
                name: 'status', 
                type: "Selection",
                label: 'Trạng thái',
                dataType: 'Label',
                class: 'center',
                width: 8,
                options: [{ value: 1, label: 'Hoàn thành', style: 'color: #00CC00; font-weight: 500;'}, { value: 0, label: 'Mới', style: 'color: #FF0000; font-weight: 500;'}, { value: 2, label: 'Huỷ', style: 'color: #333; font-weight: 500;'}]
            }
        },)
    }

}